import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    "common": {
      "black": "rgba(0, 0, 0, 1)",
      "white": "rgba(252, 252, 252, 1)",
      'dark': '#878787',
      'default': '#0D0D0D',
    },
    "background": {
      "paper": "#FFFFFF",
      "default": "#FAFAFA",
      "header": "#F82A5C",
    },
    "primary": {
      "light": "rgba(255, 255, 255, 1)",
      "main": "#0FBA2B",
      "dark": "rgba(75, 80, 111, 1)",
      "contrastText": "#fff"
    },
    "secondary": {
      "light": "rgba(223, 97, 183, 1)",
      "main": "#f82c5a",
      "dark": "rgba(104, 15, 75, 1)",
      "contrastText": "#fff"
    },
    "error": {
      "light": "#e57373",
      "main": "#f44336",
      "dark": "#d32f2f",
      "contrastText": "#fff"
    },
    "text": {
      "primary": "#0FBA2B",
      "secondary": "#a4b3bd",
      "disabled": "rgba(37, 27, 27, 0.38)",
      "hint": "rgba(0, 0, 0, 0.38)"
    },
    'divider': '#F0F0F0',
  },
});

export default theme;